.timerWrapper {
	color:  #FFFBF1;
	width: 100%;
	max-width: 470px;
	min-height: 66px;
	background: #FF8E00;
	box-shadow: 1px -3px 20px 0px rgba(255, 255, 255, 0.50) inset;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0 20px 0 20px;
}

.timerText,
.timerCellNumber,
.timerCellDivider {
	font-family: ui-rounded, "SF Pro Rounded", Nunito, "SF Pro Text", -apple-system, BlinkMacSystemFont, "Roboto", sans-serif;
	font-weight: 700;
}

.timerText {
	font-size: 19px;
	line-height: 24px;
	letter-spacing: 0.076px;
}

.timerTime {
  display: flex;
  width: 86px;
  justify-content: center;
}

.timerCell {
	display: flex;
	flex-direction: column;
	align-items: center;
}

.timerCellNumber {
	font-size: 28px;
	line-height: 34px;
	letter-spacing: -0.4px;
}

.timerCellDivider {
	font-size: 28px;
	line-height: 28px;
	letter-spacing: -0.4px;
	opacity: 0.5;
	margin: 0 2px 0 2px;
}
